import React from 'react';
import { Box, Grid, styled, Typography } from '@material-ui/core';
import palette from 'theme/palette';

const StyledBox = styled(Box)({
  border: `2px solid ${palette.navSuperAdmin}`,
  background: palette.lightGray,
  borderRadius: 8,
  width: '100%',
  display: 'flex',
  marginTop: 12,
  padding: 8,
});

interface BoxSectionProps {
  title: string;
  form: JSX.Element;
}

const BoxSection: React.FC<BoxSectionProps> = ({ title, form }) => {
  return (
    <StyledBox>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography>{title}</Typography>
        </Grid>

        {form}
      </Grid>
    </StyledBox>
  );
};

export default BoxSection;
